import React, { useState } from 'react'
import Modal from './Modal'
import { newCar } from '../../functions/stateList'
import CarModalInput from '../inputs/CarModalInput'
import CarModalSelect from '../inputs/CarModalSelect'
import ModalSubmitFormButton from '../buttons/ModalSubmitFormButton'
import PlateInput from '../inputs/PlateInput'
import { addCarSubmitHandler } from '../../functions/AddCarModalSubmit'

function AddCarModal({ cars, setCars, customer, car_models, setUserResult }) {
  const [inputs, setInputs] = useState({
    ...newCar,
  })

  const [error, setError] = useState({
    ...newCar,
  })
  const [isSubmit, setIsSubmit] = useState(false)

  const inputHandler = (e) => {
    let name = e.target.name
    let value = e.target.value

    setInputs({
      ...inputs,
      [name]: value,
    })
    setError({
      ...error,
      [name]: '',
    })
  }

  const formHandler = async (e) => {
    e.preventDefault()
    setIsSubmit(true)
    await addCarSubmitHandler(
      setIsSubmit,
      inputs,
      setUserResult,
      setError,
      error,
      customer,
      cars,
      setCars
    )
  }

  return (
    <Modal>
      <form onSubmit={formHandler}>
        {/*header*/}
        <div className="p-3 md:p-5">
          <h3 className="text-xl md:text-3xl font-semibold text-center dark:text-amber-100">
            اطلاعات خودرو
          </h3>
        </div>

        {/*body*/}
        <div className="relative p-6 flex flex-col">
          <CarModalSelect
            title={'نوع خودرو'}
            isSubmit={isSubmit}
            name={'car_model'}
            value={inputs?.car_model}
            inputHandler={inputHandler}
            error={error}
            list={car_models}
            text_key={'model'}
          />

          <CarModalInput
            title={'رنگ خودرو'}
            type={'text'}
            isSubmit={isSubmit}
            name={'color'}
            value={inputs?.color}
            inputHandler={inputHandler}
            error={error}
          />

          <CarModalInput
            maxLength={9}
            title={'میانگین پیمایش در ماه'}
            type={'number'}
            isSubmit={isSubmit}
            name={'monthly_ride'}
            value={inputs?.monthly_ride}
            inputHandler={inputHandler}
            error={error}
          />

          <PlateInput
            isSubmit={isSubmit}
            inputHandler={inputHandler}
            error={error}
            inputs={inputs}
            setInputs={setInputs}
          />
        </div>

        {/*footer*/}
        <ModalSubmitFormButton
          allowToEnter={
            (inputs?.aras_plate?.length === 5 ||
              inputs?.aras_plate?.length === 7 ||
              inputs?.first?.length > 0 ||
              inputs?.second?.length > 0 ||
              inputs?.state?.length > 0) &&
            true
          }
          setShowModal={setUserResult}
          isSubmit={isSubmit}
        />
      </form>
    </Modal>
  )
}

export default React.memo(AddCarModal)
